const getPrimaryCollection = (collections) =>
  [...collections].find(({name}) => name === 'Portfolio') ||
  [...collections]?.[0] ||
  null;

export default getPrimaryCollection;
